import { api } from './authService';

export const usersService = {
  // Получить пользователя по ID
  getUser: async (userId) => {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },
  
  // Обновить пользователя
  updateUser: async (userId, data) => {
    const response = await api.put(`/users/${userId}`, data);
    return response.data;
  },
  
  // Получить всех пользователей
  getAllUsers: async () => {
    const response = await api.get('/users/all');
    return response.data;
  },
  
  // Получить текущего пользователя
  getCurrentUser: async () => {
    const response = await api.get('/users/me');
    return response.data;
  },
  
  // Поиск пользователей по имени
  searchUsers: async (query) => {
    const response = await api.get(`/users/search?query=${encodeURIComponent(query)}`);
    return response.data;
  },
};